import { AuthActions } from "../LoginRedux/Action";
import { newPasswordActions } from "./action";

const initState = {
  changePasswordMsg: null,
  changePasswordError: null,
};

export const newPasswordReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case newPasswordActions.NEW_PASSWORD_SUCCESS:
      return {
        ...state,
        changePasswordMsg: payload,
        changePasswordError: null,
      };

    case newPasswordActions.NEW_PASSWORD_ERROR:
      return {
        ...state,
        changePasswordError: payload,
        changePasswordMsg: null,
      };

    case AuthActions.Logout_User:
      return {
        ...initState,
      };
    default:
      return state;
  }
};
